<template>
  <section class="stage-content">
    <div v-show="step > 2" @click="setStep(2)" class="stage-text" key="stage-selected">
      <div>Assentos:</div>
      <div v-if="!withSection">
        <div v-for="(item, index) in seats" :key="index" class="stage-seat">{{ item.seats }}</div>
      </div>
      <div v-else>
        <div v-for="(item, index) in seats" :key="index" class="stage-seat">{{ item.section ? item.section.replace(/_/g, " ") : '' }} - {{ item.seats }}</div>
      </div>
      <!--<div v-if="selected.length > 4" class="stage-seat">+{{ selected.length - 4 }}</div>-->
      <i class="show-date-toggle fas fa-angle-down"></i>
    </div>
    <div v-show="step < 3" key="stage-select" style="margin-bottom: 15px; padding-bottom: 15px">
      <transition name="pop" mode="out-in">
        <div v-if="loading" class="loading-stage"><i class="fas fa-spinner loading"></i></div>
      </transition>
      <transition name="pop" mode="out-in" v-if="!withSection">
        <div v-if="selected.length === 0" key="price-info" class="price-info">
          <div v-for="price in prices" :key="price.id" v-show="price.active" class="price-info-item" :class="{ 'special' : price.special }">
            <template v-if="price.table">
              <div class="price-info-type" style="text-transform: capitalize">{{ price.ticketType }}</div>
              <span v-if="price.ticketDesc" class="price-desc" v-tooltip="price.ticketDesc"><i class="fas fa-info-circle"></i></span>
              <div class="price-info-value">R$ {{ price.priceTotal.toLocaleString('pt-br', { minimumFractionDigits: 2 }) }}</div>
            </template>
            <template v-else>
              <div class="price-info-type" :class="{ 'lock-sold' : price.ticketType.toUpperCase().startsWith('MEIA') && price.available === 0 }" style="text-transform: capitalize">{{ price.ticketType.toUpperCase().startsWith('MEIA') && price.available === 0 ? price.ticketType + ' ESGOTADO*' : price.ticketType }}</div>
              <span v-if="price.ticketDesc" class="price-desc" v-tooltip="price.ticketDesc"><i class="fas fa-info-circle"></i></span>
              <div class="price-info-value"  :class="{ 'lock-sold-price' : price.ticketType.toUpperCase().startsWith('MEIA') && price.available === 0 }">R$ {{ price.price.toLocaleString('pt-br', { minimumFractionDigits: 2 }) }}</div>
            </template>
          </div>
          <div style="font-size: 0.7em" v-if="meiaSoldOut">*O número de ingressos meia-entrada vendidos para esse espetáculo já atingiu a cota de 40% do total de ingressos disponíveis para venda ao público em geral, conforme Decreto Federal nº 8.537 e Leis Federais n° 12.933 e n° 12.852.</div>
        </div>
        <div v-if="selected.length > 0" key="button-new" class="button-group">
          <div class="button-seat"><i class="fas fa-chair"></i><span>{{ selected.join(', ') }}</span></div>
          <div @click="finishSelection" class="button-buy"><span>Continuar</span><i class="fas fa-angle-right"></i></div>
        </div>
      </transition>
      <transition name="pop" mode="out-in" v-else>
        <div v-if="selected.length === 0" key="price-info" class="price-info">
          <div v-for="price in prices" :key="price.id" class="price-info-item" :class="{ 'special' : price.special }">
            <div class="price-info-type" style="text-transform: capitalize; font-weight: bold;">{{ price.section ? price.section.replace(/_/g, " ") : '' }}</div>
            <div class="price-info-type" style="text-transform: capitalize">{{ price.ticketType }}</div>
            <span v-if="price.ticketDesc" class="price-desc" v-tooltip="price.ticketDesc"><i class="fas fa-info-circle"></i></span>
            <div class="price-info-value">R$ {{ (price.table ? price.priceTotal : price.price).toLocaleString('pt-br', { minimumFractionDigits: 2 }) }}</div>
          </div>
        </div>
        <!-- <div v-else-if="selected.length === 0 && withSection" key="price-info-section" class="price-info with-section">
          <div v-for="price in sectionPrices" :key="price.id" style="margin: auto">
            <div class="price-info-item">
              <div class="price-info-type" style="text-transform: capitalize; font-weight: bold;">{{ price.section.replace(/_/g, " ") }}</div>
              <div class="price-info-type">Ingressos entre</div>
              <span v-if="price.ticketDesc" @click="ticketDesc = price" style="margin:0 5px 0 0;font-size:18px;cursor:pointer;"><i class="fas fa-info-circle"></i></span>
              <div class="price-info-value">R$ {{ price.min.toLocaleString('pt-br', { minimumFractionDigits: 2 }) }}</div>
              <div class="price-info-type">e</div>
              <div class="price-info-value">R$ {{ price.max.toLocaleString('pt-br', { minimumFractionDigits: 2 }) }}</div>
            </div>
          </div>
        </div> -->
        <div v-if="selected.length > 0" key="button-new-section" class="button-group">
          <div class="button-seat"><i class="fas fa-chair"></i><span>{{ selected.map(x => x.id).join(', ') }}</span></div>
          <div @click="finishSelection" class="button-buy"><span>Continuar</span><i class="fas fa-angle-right"></i></div>
        </div>
      </transition>
      <div class="legends" key="legends-header">
        <div class="legend">
          <div class="circle green"></div>
          <span>Assento Disponível</span>
        </div>
        <div class="legend">
          <div class="circle gray"></div>
          <span>Assento Indisponível</span>
        </div>
      </div>

      <div
        v-if="hasStages"
        class="form-group align-center online-selector"
        style="align-items: center;"
      >
        <Selector
          class="custom-selector"
          style="width: 200px"
          v-model="selectedStage"
          :options="stages.map(x => {
            return {
              text: x.name,
              value: x
            }
          })"
        />
      </div>

      <div ref="stageContainer" class="stage-container">
        <div v-html="stageSvg" id="stage" class="stage"></div>
        <!-- <div @click="svgZoom.zoomIn()" class="svgZoomIn"><i class="fas fa-plus"></i></div>
        <div @click="updateStage(true)" class="svgZoomReset"><i class="fas fa-sync-alt"></i></div>
        <div @click="svgZoom.zoomOut()" class="svgZoomOut"><i class="fas fa-minus"></i></div> -->
      </div>
      <div class="legends" key="legends-footer">
        <div class="legend">
          <div class="circle green"></div>
          <span>Assento Disponível</span>
        </div>
        <div class="legend">
          <div class="circle gray"></div>
          <span>Assento Indisponível</span>
        </div>
      </div>
      <div v-if="selected.length > 0 && withSection" key="button-new-section" class="button-group">
        <div class="button-seat"><i class="fas fa-chair"></i><span>{{ selected.map(x => x.id).join(', ') }}</span></div>
        <div @click="finishSelection" class="button-buy"><span>Continuar</span><i class="fas fa-angle-right"></i></div>
      </div>
      <div v-else-if="!withSection && selected.length > 0" key="button-new" class="button-group">
        <div class="button-seat"><i class="fas fa-chair"></i><span>{{ selected.join(', ') }}</span></div>
        <div @click="finishSelection" class="button-buy"><span>Continuar</span><i class="fas fa-angle-right"></i></div>
      </div>
    </div>
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="0" height="0" style="display: block">
      <defs>
        <linearGradient id="color-ticket-book" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stop-color="#777777"/>
          <stop offset="100%" stop-color="#aaaaaa"/>
        </linearGradient>
        <linearGradient id="color-ticket-selected" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stop-color="#0071b3"/>
          <stop offset="100%" stop-color="#0098b3"/>
        </linearGradient>
        <linearGradient id="color-ticket-empty" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stop-color="#4caf50"/>
          <stop offset="100%" stop-color="#397b3c"/>
        </linearGradient>
        <linearGradient id="color-ticket-special" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stop-color="#15158a"/>
          <stop offset="100%" stop-color="#2323f0"/>
        </linearGradient>
      </defs>
    </svg>
  </section>
</template>

<script>
import { mapState } from 'vuex'
// import svgPanZoom from 'svg-pan-zoom/src/svg-pan-zoom.js'
import logger from '../../logger'
import Selector from './Selector.vue'
import { getAll as getTickets, reserve } from '../api/ticket'
let countStage = 1

export default {
  components: { Selector },
  name: 'showStage',
  props: [
    'step',
    'setStep',
    'withoutStage',
    'withSection',
    'stage',
    'showDate',
    'prices',
    'finishStage',
    'ticketsReserved',
    'maxTicketUser',
    'preview'
  ],
  data () {
    return {
      loading: true,
      svgZoom: null,
      stageSvg: null,
      tickets: [],
      selected: [],
      seats: [],
      selectedStage: null,
      hasStages: false,
      stages: [
        {
          id: 'Piso_Inferior',
          name: 'Piso Inferior'
        },
        {
          id: 'Piso_superior',
          name: 'Piso Superior'
        }
      ],
      finished: false
    }
  },
  computed: {
    ...mapState(['user', 'reserved']),
    sectionPrices () {
      if (this.withSection) {
        const sections = this.removeDupes(this.prices.map(x => x.section))
        return sections.map(x => {
          const sectionPrices = this.prices.filter(y => y.section === x).map(y => y.price).sort(this.arraySort)
          return {
            section: x,
            min: sectionPrices[0],
            max: sectionPrices[sectionPrices.length - 1]
          }
        })
      } else return []
    },
    meiaSoldOut () {
      if (this.prices.filter(x => x.ticketType.toUpperCase().startsWith('MEIA') && x.available === 0).length > 0) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    selected: {
      handler: 'callSeats',
      deep: true
    },
    selectedStage (value) {
      this.selectStage(value)
    },
    showDate (value) {
      if (this.withoutStage) return false
      // Check if has tickets reserved
      if (this.ticketsReserved.length > 0) {
        if (this.withSection) {
          this.selected = this.ticketsReserved.map(x => ({ id: x.seat, section: x.section }))
          this.callSeats()
          this.updateStage()
        } else {
          this.selected = this.ticketsReserved.map(x => x.seat)
          this.callSeats()
          this.updateStage()
        }
      } else {
        this.updateStage(true)
      }
    }
  },
  async mounted () {
    try {
      // Enable zoom
      const viewportmeta = document.querySelector('meta[name=viewport]')
      viewportmeta.setAttribute('content', 'width=device-width, user-scalable=yes, initial-scale=1, minimum-scale=1, maximum-scale=2')
      // Set stage
      this.stageSvg = this.stage
      this.selectedStage = this.stages[0]
      // Set click events
      this.$nextTick(() => {
        this.hasStages = document.getElementsByClassName('hasStages').length > 0
        Array.from(document.getElementById('stage').querySelectorAll('g')).filter(x => {
          if (this.hasStages) {
            if ((x.children[0].id && x.children[0].tagName === 'circle') || (x.children[0].tagName === 'path' && x.children[0].id.length <= 10 && x.children[0].id.length >= 2)) return true
            else return false
          } else return true
        }).forEach(x => {
          if (x.children[0] && (x.children[0].tagName === 'circle' || x.children[0].tagName === 'path')) {
            x.style = '-webkit-tap-highlight-color: transparent;-webkit-touch-callout: none;-webkit-user-select: none;-khtml-user-select: none;-moz-user-select: none;-ms-user-select: none;user-select: none;'
            x.onclick = (e) => {
              const seat = x.children[0]
              // If user is not authenticated, calls signin screen
              const ticket = this.tickets.find(y => y.seat === seat.id)
              if (ticket && ticket.status === 'blocked') return
              if (!this.user) {
                // Reset zoom
                const viewportmeta = document.querySelector('meta[name=viewport]')
                viewportmeta.setAttribute('content', 'width=device-width, user-scalable=yes, initial-scale=1, minimum-scale=1, maximum-scale=1')
                setTimeout(() => {
                  viewportmeta.setAttribute('content', 'width=device-width, user-scalable=yes, initial-scale=1, minimum-scale=1, maximum-scale=2')
                }, 500)
                this.$store.commit('showLogin', true)
                return false
              }
              if (this.withSection && this.selected.map(x => x.id).indexOf(seat.id) > -1) {
                this.selected = this.selected.filter(y => y.id !== seat.id)
                if (ticket && ticket.special) {
                  seat.style.fill = 'url(#color-ticket-special) #15158a'
                } else {
                  seat.style.fill = 'url(#color-ticket-empty) #4caf50'
                }
                // Mesa
                if (x.parentElement.getAttribute('data-name') === 'Table') {
                  const seats = Array.from(x.parentElement.children).filter((y, i, a) => i < a.length - 1).map(x => x.children[0].id)
                  if (this.tickets.filter(y => seats.includes(y.seat)).length === 0 && this.prices.find(y => y.ticketType.substr(0, 5) === 'Mesa ' && y.ticketType.split(' ')[1] === String(seats.length))) {
                    x.parentElement.children[x.parentElement.children.length - 1].children[0].style.fill = 'url(#color-ticket-empty) #4caf50'
                  }
                }
              } else if (this.selected.indexOf(seat.id) > -1) {
                this.selected = this.selected.filter(y => y !== seat.id)
                if (ticket && ticket.special) {
                  seat.style.fill = 'url(#color-ticket-special) #15158a'
                } else {
                  seat.style.fill = 'url(#color-ticket-empty) #4caf50'
                }
                // Mesa
                if (x.parentElement.getAttribute('data-name') === 'Table') {
                  const seats = Array.from(x.parentElement.children).filter((y, i, a) => i < a.length - 1).map(x => x.children[0].id)
                  if (this.tickets.filter(y => seats.includes(y.seat)).length === 0 && this.prices.find(y => y.ticketType.substr(0, 5) === 'Mesa ' && y.ticketType.split(' ')[1] === String(seats.length))) {
                    x.parentElement.children[x.parentElement.children.length - 1].children[0].style.fill = 'url(#color-ticket-empty) #4caf50'
                  }
                }
              // Previous reserved
              } else if (this.ticketsReserved.find(y => y.seat === seat.id)) {
                if (this.selected.length === this.maxTicketUser) return false
                if (this.withSection) {
                  this.selected.push({
                    id: seat.id,
                    section: seat.parentElement.parentElement.parentElement.id
                  })
                  seat.style.fill = 'url(#color-ticket-selected) #0071b3'
                } else {
                  this.selected.push(seat.id)
                  seat.style.fill = 'url(#color-ticket-selected) #0071b3'
                }
                // Mesa
                if (x.parentElement.getAttribute('data-name') === 'Table') {
                  const seats = Array.from(x.parentElement.children).filter((y, i, a) => i < a.length - 1).map(x => x.children[0].id)
                  if (this.selected.filter(y => seats.includes(this.withSection ? y.id : y)).length === seats.length) {
                    if (this.prices.find(y => y.ticketType.substr(0, 5) === 'Mesa ' && y.ticketType.split(' ')[1] === String(seats.length))) {
                      x.parentElement.children[x.parentElement.children.length - 1].children[0].style.fill = 'url(#color-ticket-selected) #0071b3'
                    }
                  }
                }
              // Check max tickets per user
              } else if (!ticket || (ticket && ticket.status === 'book' && ticket.special)) {
                // Check max tickets per user
                if (this.selected.length === this.maxTicketUser) return false
                if (this.withSection) {
                  this.selected.push({
                    id: seat.id,
                    section: seat.parentElement.parentElement.parentElement.id
                  })
                } else this.selected.push(seat.id)
                seat.style.fill = 'url(#color-ticket-selected) #0071b3'
                // Mesa
                if (x.parentElement.getAttribute('data-name') === 'Table') {
                  const seats = Array.from(x.parentElement.children).filter((y, i, a) => i < a.length - 1).map(x => x.children[0].id)
                  if (this.selected.filter(y => seats.includes(this.withSection ? y.id : y)).length === seats.length) {
                    if (this.prices.find(y => y.ticketType.substr(0, 5) === 'Mesa ' && y.ticketType.split(' ')[1] === String(seats.length))) {
                      x.parentElement.children[x.parentElement.children.length - 1].children[0].style.fill = 'url(#color-ticket-selected) #0071b3'
                    }
                  }
                }
              }
            }
          }
        })
        // Click na mesa
        Array.from(document.getElementById('stage').querySelectorAll('[data-name=Table]')).forEach(x => {
          x.onclick = (e) => {
            if (String(e.target.parentElement.id).substr(0, 4) === 'Mesa') {
              if (!this.user) {
                // Reset zoom
                const viewportmeta = document.querySelector('meta[name=viewport]')
                viewportmeta.setAttribute('content', 'width=device-width, user-scalable=yes, initial-scale=1, minimum-scale=1, maximum-scale=1')
                setTimeout(() => {
                  viewportmeta.setAttribute('content', 'width=device-width, user-scalable=yes, initial-scale=1, minimum-scale=1, maximum-scale=2')
                }, 500)
                this.$store.commit('showLogin', true)
                return false
              }
              const seatsG = Array.from(x.children).filter(y => y.id.substr(0, 7) === 'Assento')
              const seats = seatsG.map(y => y.children[0])
              const seatsId = seats.map(y => y.id)
              if (!this.prices.find(y => y.ticketType.substr(0, 5) === 'Mesa ' && y.ticketType.split(' ')[1] === String(seats.length))) return false
              if (this.selected.filter(y => seatsId.includes(this.withSection ? y.id : y)).length === seats.length) {
                if (this.withSection) {
                  this.selected = this.selected.filter(y => !seatsId.includes(y.id))
                } else {
                  this.selected = this.selected.filter(y => !seatsId.includes(y))
                }
                seats.forEach(y => {
                  y.style.fill = 'url(#color-ticket-empty) #4caf50'
                })
                x.children[x.children.length - 1].children[0].style.fill = 'url(#color-ticket-empty) #4caf50'
              } else if (this.tickets.filter(y => seatsId.includes(y.seat)).length === 0) {
                seats.forEach(y => {
                  if (!this.selected.find(z => y.id === (this.withSection ? z.id : z))) {
                    if (this.withSection) {
                      this.selected.push({
                        id: y.id,
                        section: y.parentElement.parentElement.parentElement.id
                      })
                    } else {
                      this.selected.push(y.id)
                    }
                  }
                  y.style.fill = 'url(#color-ticket-selected) #0071b3'
                })
                x.children[x.children.length - 1].children[0].style.fill = 'url(#color-ticket-selected) #0071b3'
              }
            }
          }
        })
      })
      // Update stage
      // this.updateStage()
      // this.callSeats()
    } catch (error) {
      logger.error(error, this)
    }
  },
  destroyed () {
    // Disable zoom
    const viewportmeta = document.querySelector('meta[name=viewport]')
    viewportmeta.setAttribute('content', 'width=device-width, user-scalable=yes, initial-scale=1, minimum-scale=1, maximum-scale=1')
  },
  methods: {
    callSeats () {
      this.seats = []
      if (this.withSection) {
        for (let i = 0; i < this.selected.length; i++) {
          if (this.seats.length === 0) {
            this.seats.push({ section: this.selected[i].section, seats: this.selected[i].id })
          } else {
            let found = false
            for (let a = 0; a < this.seats.length; a++) {
              if (this.seats[a].section === this.selected[i].section) {
                this.seats[a].seats = this.seats[a].seats + ', ' + this.selected[i].id
                found = true
              }
            }
            if (!found) {
              this.seats.push({ section: this.selected[i].section, seats: this.selected[i].id })
            }
          }
        }
      } else {
        for (let i = 0; i < this.selected.length; i++) {
          if (this.seats.length === 0) {
            this.seats.push({ seats: this.selected[i] })
          } else {
            this.seats[0].seats = this.seats[0].seats + ', ' + this.selected[i]
          }
        }
      }
    },
    selectStage (stage) {
      this.selectedStage = stage
      this.stages.forEach(x => {
        if (stage !== x && document.getElementById(x.id)) {
          document.getElementById(x.id).style.display = 'none'
        } else if (stage === x && document.getElementById(x.id)) {
          document.getElementById(x.id).style.display = 'initial'
        }
      })
    },
    arraySort (a, b) {
      if (a > b) return 1
      else if (a < b) return -1
      else return 0
    },
    removeDupes (array) {
      const newArray = []
      array.forEach(x => { if (!newArray.includes(x)) newArray.push(x) })
      return newArray
    },
    async finishSelection () {
      if (this.loading) {
        return false
      }
      this.loading = true
      try {
        if (this.preview) {
          const tickets = this.selected.map(x => ({
            id: null,
            section: 1,
            seat: x,
            created: new Date(),
            showPrice: null
          }))
          this.finished = true
          this.finishStage(tickets, new Date())
          this.loading = false
        } else {
          const data = await reserve(this.showDate, this.selected, this.withSection)
          if (!data) return false
          this.finished = true
          this.finishStage(data.tickets, data.now)
          this.$store.commit('reserved', { ...this.reserve, tickets: data.tickets })
          this.loading = false
        }
      } catch (error) {
        this.loading = false
        const data = error.response ? error.response.data : {}
        // Validation error
        if (data.error === 'Validation error') {
          alert('Esses assentos já foram escolhidos')
        } else {
          logger.error(error, this)
        }
      }
    },
    async updateStage (clean = false) {
      this.finished = false
      this.loading = true
      if (clean) this.selected = []
      if (!this.showDate) {
        this.loading = false
        return false
      }
      try {
        this.tickets = await getTickets(this.showDate)
      } catch (error) {
        logger.error(error, this)
      }
      this.$nextTick(() => {
        if (!this.withSection) {
          Array.from(document.getElementsByClassName('exibir')).forEach(x => {
            x.classList.add('esconder')
          })
        }
        // this.$refs['stage-container'].style.height = `${window.innerHeight - 260}px`
        window.scroll(0, document.getElementById('show-align').offsetTop)
        // document.getElementById('show-align').scrollIntoView({ behavior: 'instant', block: 'center' })
        // document.getElementById('show-align').scrollIntoView({ behavior: 'smooth', block: 'start' })
        // this.svgZoom.resize()
        // this.svgZoom.fit()
        // this.svgZoom.center()
        document.getElementById('stage').querySelectorAll('g').forEach(x => {
          if (x.querySelector('svg')) {
            x.querySelector('svg').style.display = 'none'
            x.querySelector('text').style.display = 'block'
          }
          // Fill circles
          const circle = x.children[0]
          const ticket = this.tickets.find(y => y.seat === circle.id)
          // Special
          if (ticket && ticket.special) {
            x.querySelector('text').style.display = 'none'
            if (x.querySelector('svg')) {
              x.querySelector('svg').style.display = 'block'
            } else {
              const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
              svg.setAttributeNS(null, 'viewBox', '0 0 512 512')
              svg.setAttributeNS(null, 'width', 12)
              svg.setAttributeNS(null, 'height', 12)
              svg.setAttributeNS(null, 'x', Number(circle.getAttribute('cx')) - Number(circle.getAttribute('r')) + 2)
              svg.setAttributeNS(null, 'y', Number(circle.getAttribute('cy')) - Number(circle.getAttribute('r')) + 1)
              const path = document.createElementNS('http://www.w3.org/2000/svg', 'path')
              path.setAttributeNS(null, 'fill', 'white')
              path.setAttributeNS(null, 'd', 'M496.101 385.669l14.227 28.663c3.929 7.915.697 17.516-7.218 21.445l-65.465 32.886c-16.049 7.967-35.556 1.194-43.189-15.055L331.679 320H192c-15.925 0-29.426-11.71-31.679-27.475C126.433 55.308 128.38 70.044 128 64c0-36.358 30.318-65.635 67.052-63.929 33.271 1.545 60.048 28.905 60.925 62.201.868 32.933-23.152 60.423-54.608 65.039l4.67 32.69H336c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16H215.182l4.572 32H352a32 32 0 0 1 28.962 18.392L438.477 396.8l36.178-18.349c7.915-3.929 17.517-.697 21.446 7.218zM311.358 352h-24.506c-7.788 54.204-54.528 96-110.852 96-61.757 0-112-50.243-112-112 0-41.505 22.694-77.809 56.324-97.156-3.712-25.965-6.844-47.86-9.488-66.333C45.956 198.464 0 261.963 0 336c0 97.047 78.953 176 176 176 71.87 0 133.806-43.308 161.11-105.192L311.358 352z')
              svg.appendChild(path)
              x.appendChild(svg)
            }
          } else if (ticket && ticket.status === 'blocked') {
            x.style.cursor = 'not-allowed'
            x.children[0].style.fill = '#d2d2d2'
            x.children[0].style.cursor = 'normal'
            x.children[1].textContent = 'X'
          }
          if (this.withSection && this.selected.map(x => x.id).indexOf(circle.id) > -1) circle.style.fill = 'url(#color-ticket-selected) #0071b3'
          else if (this.selected.indexOf(circle.id) > -1) circle.style.fill = 'url(#color-ticket-selected) #0071b3'
          else if (ticket && ticket.status === 'book' && ticket.special) circle.style.fill = 'url(#color-ticket-special) #15158a'
          else if (ticket) circle.style.fill = 'url(#color-ticket-book) #777777'
          else if (this.hasStages) {
            if ((x.children[0].id && x.children[0].tagName === 'circle') || (x.children[0].tagName === 'path' && x.children[0].id.length <= 10 && x.children[0].id.length >= 2)) circle.style.fill = 'url(#color-ticket-empty) #4caf50'
          } else {
            if (x.children[0].tagName !== 'rect') {
              circle.style.fill = 'url(#color-ticket-empty) #4caf50'
            }
          }
        })
        // Mesas
        document.getElementById('stage').querySelectorAll('[data-name=Table]').forEach(x => {
          const tablePath = x.children[x.children.length - 1].children[0]
          if (tablePath) {
            tablePath.style.fill = 'url(#color-ticket-empty) #4caf50'
            const seats = Array.from(x.children).filter((y, i, a) => i < a.length - 1).map(x => x.children[0].id)
            const hasTable = !!this.prices.find(y => y.ticketType.substr(0, 5) === 'Mesa ' && y.ticketType.split(' ')[1] === String(seats.length))
            if (!hasTable) tablePath.style.fill = 'url(#color-ticket-book) #777777'
            else if (this.selected.filter(y => seats.includes(this.withSection ? y.id : y)).length === seats.length) tablePath.style.fill = 'url(#color-ticket-selected) #0071b3'
            else if (this.tickets.filter(y => seats.includes(y.seat)).length > 0) tablePath.style.fill = 'url(#color-ticket-book) #777777'
          }
        })
      })
      this.loading = false
      this.$nextTick(() => {
        this.selectStage(this.selectedStage)
      })
      // Solução alternativa para corrigir distorção da fonte
      if (document.getElementById('Assentos')) {
        document.getElementById('Assentos').style.zoom = 1 + (countStage / 100)
        countStage++
      }
    },
    isSelectedStage (x) {
      return x.parentNode.parentNode.parentNode.parentNode.id === this.selectedStage.id
    },
    showStage () {
      this.finished = false
      this.$nextTick(() => {
        // this.$refs['stage-container'].style.height = `${window.innerHeight - 260}px`
        window.scroll(0, document.getElementById('show-align').offsetTop)
        // this.svgZoom.resize()
        // this.svgZoom.fit()
        // this.svgZoom.center()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";
.lock-sold {
  color: #999 !important;
}
.lock-sold-price {
  background-image: linear-gradient(to bottom right, #999, #999) !important;
}

.online-selector {
  height: 73px;
  display: flex !important;
  flex-direction: column !important;
  justify-content: center !important;
}

/deep/ .selector {
  background-color: #cccccc;
  color: #595959;
  font-size: 0.8em;
  padding: 2.5px;
  .selector-option {
    color: #595959;
    padding: 7px;
  }
}

.legends {
  display: flex;
  justify-content: center;
  .legend {
    display: flex;
    align-items: center;
    font-size: 0.8rem;
    margin: 4px;
    .circle {
      border-radius: 15px;
      width: 15px;
      height: 15px;
      margin: 5px;
    }
    .green { background-color: #4caf50; }
    .gray { background-color: #777777; }
  }
}

.sticky {
  position: fixed;
  top: 0;
  width: 100%;
}

.stage-text {
  display: flex;
  align-items: center;
  width: 100%;
  color: #333;
  font-size: 1em;
  font-weight: 300;
  width: 100%;
  margin-bottom: 15px;
  padding-bottom: 15px;
  border-bottom: 1px solid #d5d5d5;
  .stage-seat {
    color: $primary-color;
    font-size: 1.1em;
    font-weight: 500;
    margin-left: 10px;
  }
  i {
    flex: 1;
    text-align: right;
    cursor: pointer;
    font-size: 1.6em;
    color: #999;
  }
}

.stage-content {
  position: relative;
  width: 100%;
}

.loading-stage {
  // background-color: rgba(255, 255, 255, 0.5);
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 9;
  display: flex;
  justify-content: center;
  align-items: center;
  i {
    font-size: 60px;
    color: $primary-color;
  }
}

.button-group {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
}

.button-buy {
  display: flex;
  align-items: center;
  color: #fff;
  border: none;
  border: 1px solid $primary-color;
  border-radius: 100px;
  box-shadow: 2px 2px 10px 0px rgba(0,0,0,0.4);
  background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
  font-size: 1em;
  font-weight: 500;
  height: 40px;
  padding: 0 15px;
  cursor: pointer;
  margin-right: 5px;
  &:focus {
    outline: 0;
  }
  i {
    margin-left: 7px;
    font-size: 1.2em;
  }
  &:hover {
    i {
      animation-name: ticket-next;
      animation-timing-function: ease-in-out;
      animation-duration: 0.5s;
      animation-iteration-count: 5;
    }
  }
}

.button-seat {
  display: flex;
  align-items: center;
  color: #fff;
  border: none;
  border: 1px solid #0071b3;
  border-radius: 100px;
  box-shadow: 2px 2px 10px 0px rgba(0,0,0,0.4);
  background-image: linear-gradient(to bottom right, #0071b3, #0098b3);
  font-size: 1em;
  font-weight: 500;
  min-height: 40px;
  width: auto;
  padding: 5px 15px;
  cursor: pointer;
  margin-right: 10px;
  white-space: nowrap;
  overflow: hidden;
  max-width: 80px;
  text-overflow: ellipsis;
  max-width: 120px;
  &:focus {
    outline: 0;
  }
  i {
    margin-right: 7px;
    font-size: 1.2em;
  }
}

.price-info {
  &.with-section {
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  }
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-items: center;
  margin: 0;
  min-height: 40px;

  .price-info-item {
    display: flex;
    align-items: center;
    border: 1px solid #ccc;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
    border-radius: 5px;
    margin: 5px;

    .price-info-type {
      color: $primary-color;
      font-weight: 500;
      padding: 3px 7px;
    }

    .price-info-value {
      border-radius: 5px;
      background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
      color: #fff;
      font-weight: 400;
      padding: 3px 7px;
    }

    &.special {
      .price-info-type {
        color: #15158a;
      }
      .price-info-value {
        background-image: linear-gradient(to bottom right, #15158a, #2323f0);
      }
    }
  }
}

.stage-container {
  position: relative;
  min-height: 200px;
  .stage {
    width: 100%;
    margin-top: 5px;
  }
}

.svgZoomIn {
  display: none !important;
  position: absolute;
  bottom: 0;
  right: 80px;
  background-color: #999;
  box-shadow: 2px 2px 10px 0px rgba(0,0,0,0.4);
  width: 35px;
  height: 35px;
  border-radius: 50%;
  color: #fff;
  font-size: 1em;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.svgZoomReset {
  position: absolute;
  bottom: 0;
  // right: 40px;
  right: 0;
  background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
  box-shadow: 2px 2px 10px 0px rgba(0,0,0,0.4);
  width: 35px;
  height: 35px;
  border-radius: 50%;
  color: #fff;
  font-size: 1em;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.svgZoomOut {
  display: none !important;
  position: absolute;
  bottom: 0;
  right: 0;
  background-color: #999;
  box-shadow: 2px 2px 10px 0px rgba(0,0,0,0.4);
  width: 35px;
  height: 35px;
  border-radius: 50%;
  color: #fff;
  font-size: 1em;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.price-desc {
  margin: 0 5px 0 0;
  font-size: 18px;
  cursor: pointer;
  color: #999;
}

@keyframes ticket-down {
  0% { transform: translateY(0) }
  50% { transform: translateY(5px) }
  100% { transform: translateY(0) }
}

// Desktop
@media screen and (min-width: $desktop-width) {
  .button-seat {
    max-width: 30vw;
  }
}
</style>

<style lang="scss">
.stage {
  g {
    cursor: pointer;
    &:hover {
      circle {
        fill: #aaa;
      }
    }
  }
}
</style>
